import React from "react";
import { Card, CardContent, Typography, Box, Tooltip, Chip } from "@mui/material";
import { PieceIconRow } from "./FlowStepIcons";

// Structural copy of CollectionCard.jsx (the only real gallery-grid precedent
// in this codebase) - no kebab menu here, since a read-only external template
// has no delete/share actions.
const TemplateCard = ({ template, onClick }) => {
  const { id, name, summary, tags, pieces } = template;

  return (
    <Card
      sx={{
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
        },
        height: "auto",
        minHeight: 160,
        display: "flex",
        flexDirection: "column",
      }}
      onClick={() => onClick(id)}
    >
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: 2,
        }}
      >
        <Box>
          <Box sx={{ mb: 2 }}>
            <Tooltip title={name} placement="top" arrow>
              <Typography
                variant="h6"
                component="h3"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "1.1rem",
                }}
              >
                {name}
              </Typography>
            </Tooltip>
          </Box>

          {summary && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mb: 2,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxHeight: "2.5em",
                fontSize: "0.875rem",
              }}
            >
              {summary}
            </Typography>
          )}

          {tags && tags.length > 0 && (
            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mb: 1.5 }}>
              {tags.slice(0, 2).map((tag) => (
                <Chip key={tag} label={tag} size="small" variant="outlined" />
              ))}
            </Box>
          )}
        </Box>

        <Box sx={{ mt: "auto" }}>
          <PieceIconRow pieces={pieces} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TemplateCard;
